import TableTemplate from "../TableTemplate/tableTemplate";
import { CommonTableUI } from "../TableTemplate/common";
import { IConversionReport } from "../../Interfaces/deltaHedgeExe";
import { getConversionTable } from "../../Requests/conversion";
import { IConversionSearchParam } from "../../Interfaces/conversion";

interface IProps {
  searchParams: IConversionSearchParam;
}

const ConversionTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IConversionSearchParam, IConversionReport>
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          setSortingType={setSortingType}
          sortingType={sortingType}
          tableBoxClassName="max-h-[500px] overflow-auto"
        />
      )}
      getDataTable={getConversionTable}
      searchParameters={searchParams}
      withSort
      refreshTableTime={30000}
    />
  );
};

export default ConversionTable;
